import React from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import dp from '../../assets/hero/favicon.png';
import '../../index.css';

function WhatsAppWidget() {
  return (
    <FloatingWhatsApp
      phoneNumber=" +918208053493" // Replace with your WhatsApp number
      accountName="Belantara Beach Estate" // Replace with your desired name
      avatar={dp}
      avatarStyles={{
        objectFit: 'contain',
        width: '50px !important', // Adjust dimensions
        height: '50px !important'
      }}
      statusMessage="Typically replies within a few hours"
      chatMessage="Hi there! How can we assist you today?"
      placeholder="Type your message..."
      allowClickAway // Allow closing the widget by clicking outside
      notification // Show notification bubble
      notificationDelay={60000} // Delay before showing notifications in ms (e.g., 1 minute)
    />
  );
}

export default WhatsAppWidget;
